/**
 * Portal-level role gating for feature sections. Single source of truth — imported by
 * App.tsx (route guards) and Sidebar.tsx/BottomNav.tsx (nav visibility) so the allowed-role
 * lists never drift out of sync between the two.
 *
 * These are distinct from RESTAURANT_ROLES in src/components/employees/EmployeeManagement.tsx,
 * which is the full list of roles assignable to an employee record (includes floor roles like
 * Chef/Waiter/Cashier that never get portal-level access).
 */

export const SUPER_ROLES = ['Restaurant_Owner', 'Regional_Employee', 'Magil_Admin'];

export const LOYALTY_ALLOWED_ROLES = ['Restaurant_Owner', 'Restaurant_Manager', 'Regional_Employee', 'Magil_Admin'];

export const OFFERS_ALLOWED_ROLES = ['Restaurant_Owner', 'Restaurant_Manager', 'Regional_Employee', 'Magil_Admin'];
